/* eslint-disable no-unused-vars */
const ALCHEMY_API_URL = process.env.NEXT_PUBLIC_ALCHEMY_API_URL || "";

import { AbiItem } from "web3-utils";
import axios from "axios";

import Mounts from "../../contracts/Mounts.json";
import AddRaiderMount from "../../contracts/AddRaiderMount.json";

import {
	UseToastOptions,
	ToastId,
	CloseAllToastsOptions,
} from "@chakra-ui/toast";

import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import { getManyEntities } from "./interactBank";
const web3 = createAlchemyWeb3(ALCHEMY_API_URL);

export const getAccount = async () => {
	if ((window as any).current_provider) {
		web3.setWriteProvider((window as any).current_provider)
		if ((window as any).current_provider.isMetaMask) {
			//metamask
			return (window as any).current_provider.selectedAddress
		} else {
			return (window as any).current_provider.accounts[0];
		}
	} 
};

const mountsContract = new web3.eth.Contract(
	Mounts.abi as AbiItem[],
	process.env.NEXT_PUBLIC_MOUNTS
);

const addRaiderMountContract = new web3.eth.Contract(
	AddRaiderMount.abi as AbiItem[],
	process.env.NEXT_PUBLIC_ADD_MOUNT
);

// ---------- MOUNTS CONTRACT ----------

export async function ownedMounts() {
	const account = await getAccount();
	try {
		const result = await mountsContract.methods.mountsOwnedBy(account).call();
		if (result.length) {
			return await getManyEntities(result, 'mounts')
		} else  {
			return []
		}

	} catch (err) {
		console.log(err);
	}
}

export async function approveMounts(
	toast: (options: UseToastOptions) => string | number | undefined
) {
	try {
		const account = await getAccount();
		if (account) {
			const result = await mountsContract.methods
			.setApprovalForAll(process.env.NEXT_PUBLIC_ADD_MOUNT, true)
			.send(
				{ from: account, maxPriorityFeePerGas: null, maxFeePerGas: null },
				function (err: any, res: any) {
					if (err) {
						toast({
							title: "Couldn't approve your Mount...",
							description: err.message,
							status: "error",
							duration: 9000,
							position: "top",
							isClosable: true,
						});
						console.log(err);
					}
					console.log("Hash of the transaction: " + res);
				}
			);
			return result;
		}
	} catch (err) {
		console.log(err);
	}
}

export async function areMountsApproved() {
	const account = await getAccount();
	if (account) {
		try {
			const result = await mountsContract.methods
				.isApprovedForAll(account, process.env.NEXT_PUBLIC_ADD_MOUNT)
				.call();
			return result;
		} catch (err) {
			console.log(err);
		}
	}
}

// ---------- ADD MOUNTS CONTRACT ----------

export async function isRaiderMounted(raiderId: number): Promise<boolean> {
	const result = await addRaiderMountContract.methods
		.raiderMounted(raiderId)
		.call();

	return result;
}

export async function getRaiderOnMount(mountId: number): Promise<number> {
	return await Number(addRaiderMountContract.methods
		.mountRaiderId(mountId)
		.call());
}

export async function getMountOwnerAddress(mountId: number): Promise<string> {
	return await addRaiderMountContract.methods
		.mountOwner(mountId)
		.call();
}

export async function equippedMount(raiderId: number) {
	try {
		const result = await addRaiderMountContract.methods
			.raiderMountId(raiderId)
			.call();

		let mount;

		if (result) {
			mount = await axios(`https://api.cryptoraiders.xyz/mount/${result}`);
		}

		return mount;
	} catch (err) {
		console.log(err);
	}
}

export async function addMount(
	raiderId: number,
	mountId: number,
	toast: (options: UseToastOptions) => string | number | undefined
) {
	try {
		const account = await getAccount();
		const result = await addRaiderMountContract.methods
			.addMount(raiderId, mountId)
			.send(
				{ from: account, maxPriorityFeePerGas: null, maxFeePerGas: null },
				function (err: any, res: any) {
					if (err) {
						toast({
							title: "Couldn't mount up...",
							description: err.message,
							status: "error",
							duration: 9000,
							position: "top",
							isClosable: true,
						});
						console.log(err);
					}
					console.log("Hash of the transaction: " + res);
				}
			);
		return result;
	} catch (err) {
		console.log(err);
	}
}

export async function dismount(
	raiderId: number,
	toast: (options: UseToastOptions) => string | number | undefined
) {
	try {
		const account = await getAccount();
		const result = await addRaiderMountContract.methods
			.dismount(raiderId)
			.send(
				{ from: account, maxPriorityFeePerGas: null, maxFeePerGas: null },
				function (err: any, res: any) {
					if (err) {
						toast({
							title: "Couldn't dismount...",
							description: err.message,
							status: "error",
							duration: 9000,
							position: "top",
							isClosable: true,
						});
						console.log(err);
					}
					console.log("Hash of the transaction: " + res);
				}
			);
		return result;
	} catch (err) {
		console.log(err);
	}
}
